import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_GET_IPO } from "../../../config/api";

export const deleteIpo = createAsyncThunk(
  "ipos/delete",
  async ({ id, callback, navigate }, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "DELETE",
        path: API_GET_IPO(id),
      });
      toast.success("IPO deleted successfully");
      callback && callback();
      navigate && navigate("/ipos", { replace: true });
      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
